'use client';

import { Button } from '@tuic/web-compositions/core/Button';
import { Pictogram } from '@tuic/web-compositions/core/Pictogram';
import { Skeleton } from '@tuic/web-compositions/core/Skeleton';
import type { ComponentBlock } from '@modules/prism-client/types/types';
import type { PictogramName } from '@tuic/web-compositions/core/Pictogram';
import type { ReactNode } from 'react';
export type ManifestFormSuccessBlockProps = {
  title?: ReactNode;
  paragraph?: ReactNode;
  pictogram?: PictogramName;
  pinLabel?: string;
  pin?: string;
  backToOverviewLabel?: string;
  backToOverviewHref?: string;
};
export const ManifestFormSuccessBlock: ComponentBlock<ManifestFormSuccessBlockProps> = ({
  data,
  fallback
}) => {
  if (fallback) {
    return <div className="flex flex-col items-center gap-6 text-center text-marine-high-emphasis my-16">
        <Skeleton className="h-18 w-18 rounded-full" />
        <Skeleton className="h-8 w-1/4" />
        <div className="flex w-full flex-col items-center gap-2">
          <Skeleton className="h-5 w-full" />
          <Skeleton className="h-5 w-full" />
          <Skeleton className="h-5 w-1/3" />
        </div>
        <Skeleton className="h-5 w-1/6" />
        <Skeleton className="h-11 w-1/7 rounded-md" />
      </div>;
  }
  if (!data) return null;
  const {
    title,
    paragraph,
    pictogram,
    pinLabel,
    pin,
    backToOverviewLabel,
    backToOverviewHref
  } = data;
  return <div className="my-16 flex flex-col items-center gap-6 text-center text-marine-high-emphasis" data-sentry-component="ManifestFormSuccessBlock" data-sentry-source-file="ManifestFormSuccessBlock.tsx">
      {pictogram && <Pictogram name={pictogram} size="md" />}

      {title && <h1 className="headline-lg">{title}</h1>}

      {paragraph && <div className="text-lg">{paragraph}</div>}

      {pin && <div className="flex items-center gap-3 rounded-lg bg-ocean-10 px-6 py-3">
          {pinLabel && <span className="text-lg font-semibold">{pinLabel}</span>}
          <span className="text-lg font-semibold">{pin}</span>
        </div>}

      {backToOverviewHref && backToOverviewLabel && <Button asChild>
          <a href={backToOverviewHref}>{backToOverviewLabel}</a>
        </Button>}
    </div>;
};